<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P0003600.installation.filtration.titre' | translate"
      [description]="'P0003600.installation.filtration.description' | translate"
    >
    </app-header-configuration>

    <app-label-configuration
      [title]="'P0003600.installation.filtration.programmeTitre' | translate"
      [information]="openEnSavoirPlus"
      [titleListe]="'P0003600.installation.filtration.programme' | translate"
      [description]="
        'P0003600.installation.filtration.programmeDescription' | translate
      "
      [value]="actionStack!.getValue('fsCProgrammeFiltrationAuto')"
      [liste]="
        hasProduitP00030() > 0 || hasProduitP00032() > 0
          ? P0003600ProgrammeFiltrationAuto
          : P0003600ProgrammeFiltrationAutoSans
      "
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.FiltrationStandard_Controle,
          'fsCProgrammeFiltrationAuto',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    @if (actionStack!.getValue('fsCProgrammeFiltrationAuto') === 0) {
      <app-minuterie-label
        [title]="
          'P0003600.installation.filtration.programmeTitre.0.titre' | translate
        "
        [name]="
          'P0003600.installation.filtration.programmeUsine.programmeTitre'
            | translate
        "
        [value]="convertMinutesToTime(actionStack!.getValue('fsPHeureDepart'))"
        [minuteInterval]="1"
        [startDate]="this.actionStack!.getValue('fsPHeureDepart')"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.FiltrationStandard_Parametrage,
            'fsPHeureDepart',
            $event,
            null
          )
        "
      >
      </app-minuterie-label>
    }

    @if (actionStack!.getValue('fsCProgrammeFiltrationAuto') === 1) {
      <app-minuterie-label
        [title]="
          'P0003600.installation.filtration.programmeTitre.1.titre' | translate
        "
        [name]="
          'P0003600.installation.filtration.programmeUsine.programmeTitre'
            | translate
        "
        [value]="convertMinutesToTime(actionStack!.getValue('fsPHeureDepart'))"
        [minuteInterval]="1"
        [startDate]="this.actionStack!.getValue('fsPHeureDepart')"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.FiltrationStandard_Parametrage,
            'fsPHeureDepart',
            $event,
            null
          )
        "
      >
      </app-minuterie-label>
    }

    @if (actionStack!.getValue('fsCProgrammeFiltrationAuto') === 2) {
      <app-minuterie-label
        [title]="
          'P0003600.installation.filtration.programmeTitre.2.titre' | translate
        "
        [name]="
          'P0003600.installation.filtration.programmeUsine.programmeTitre'
            | translate
        "
        [value]="convertMinutesToTime(actionStack!.getValue('fsPHeureDepart'))"
        [minuteInterval]="1"
        [startDate]="this.actionStack!.getValue('fsPHeureDepart')"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.FiltrationStandard_Parametrage,
            'fsPHeureDepart',
            $event,
            null
          )
        "
      >
      </app-minuterie-label>
    }

    @if (actionStack!.getValue('fsCProgrammeFiltrationAuto') === 6) {
      <app-minuterie-label
        [title]="
          'P0003600.installation.filtration.programmeTitre.6.titre' | translate
        "
        [name]="
          'P0003600.installation.filtration.programmeUsine.programmeTitre'
            | translate
        "
        [value]="convertMinutesToTime(actionStack!.getValue('fsPHeureDepart'))"
        [minuteInterval]="1"
        [startDate]="this.actionStack!.getValue('fsPHeureDepart')"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.FiltrationStandard_Parametrage,
            'fsPHeureDepart',
            $event,
            null
          )
        "
      >
      </app-minuterie-label>

      <app-label-configuration
        [titleListe]="
          'P0003600.installation.filtration.programmeLoiDEau.dureeAjustementLoiDEau.programmeTitre'
            | translate
        "
        [value]="actionStack!.getValue('fsPDureeAjustementLoiDEau')"
        [liste]="P0003600DureeAjustementLoiEau"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.FiltrationStandard_Parametrage,
            'fsPDureeAjustementLoiDEau',
            $event,
            null
          )
        "
      >
      </app-label-configuration>
    }

    @if (actionStack!.getValue('fsCProgrammeFiltrationAuto') === 3) {
      <app-two-choices-control
        [title]="'P0003600.installation.filtration.programmePPH' | translate"
        [firstLabel]="
          'P00039.lighting.functionality.parameters.setting.title.clock.day'
            | translate
        "
        [firstValue]="0"
        [secondLabel]="
          'P00039.lighting.functionality.parameters.setting.title.clock.week'
            | translate
        "
        [secondValue]="1"
        [value]="actionStack!.getValue('fsPTypeHorlogePPH')"
        (onChange)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.FiltrationStandard_Parametrage,
            'fsPTypeHorlogePPH',
            $event,
            null
          )
        "
      >
      </app-two-choices-control>

      @if (this.actionStack!.getValue('fsPTypeHorlogePPH') === 0) {
        <app-larged-link
          [name]="
            'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
              | translate
          "
          (onPress)="goToFunctionParametersSettingsClockScreen()"
        >
        </app-larged-link>
      } @else {
        <app-larged-link
          [name]="
            'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
              | translate
          "
          (onPress)="goToFunctionParametersSettingClockWeekScreen()"
        >
        </app-larged-link>
      }

      <app-label-description
        [description]="'P00039.parameters.setting.text.clock' | translate"
      ></app-label-description>
    }

    @if (actionStack!.getValue('fsCProgrammeFiltrationAuto') === 4) {
      <app-two-choices-control
        [title]="'P0003600.filtration.reglage.horlogeEte' | translate"
        [firstLabel]="
          'P00039.lighting.functionality.parameters.setting.title.clock.day'
            | translate
        "
        [firstValue]="0"
        [secondLabel]="
          'P00039.lighting.functionality.parameters.setting.title.clock.week'
            | translate
        "
        [secondValue]="1"
        [value]="actionStack!.getValue('fsPTypeHorlogePPE')"
        (onChange)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.FiltrationStandard_Parametrage,
            'fsPTypeHorlogePPE',
            $event,
            null
          )
        "
      >
      </app-two-choices-control>

      @if (this.actionStack!.getValue('fsPTypeHorlogePPH') === 0) {
        <app-larged-link
          [name]="
            'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
              | translate
          "
          (onPress)="goToFunctionParametersSettingsClockPPEScreen()"
        >
        </app-larged-link>
      } @else {
        <app-larged-link
          [name]="
            'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
              | translate
          "
          (onPress)="goToFunctionParametersSettingClockWeekPPEScreen()"
        >
        </app-larged-link>
      }

      <app-label-description
        [description]="'P00039.parameters.setting.text.clock' | translate"
      ></app-label-description>
    }
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
